export interface IWarehouseAdminDeliveredTotalsByPeriodPeriodData {
    from: string;
    until: string;
    total_cost: number;
}

export interface IWarehouseAdminDeliveredTotalsByPeriodProductPeriodData {
    delivered: number;
    cost: number;
}

export interface IWarehouseAdminDeliveredTotalsByPeriodProductData {
    id: number;
    name: string|null;
    category: {
        id: number;
        name: string|null;
    }|null;
    active: boolean;
    target_price: number|null;
    periods: IWarehouseAdminDeliveredTotalsByPeriodProductPeriodData[];
}

export interface IWarehouseAdminDeliveredTotalsByPeriodReportData {
    building: string;
    periods: IWarehouseAdminDeliveredTotalsByPeriodPeriodData[];
    products: IWarehouseAdminDeliveredTotalsByPeriodProductData[];
}

export class WarehouseAdminDeliveredTotalsByPeriodPeriodData {
    from: string;
    until: string;
    total_cost: number;

    constructor(data: IWarehouseAdminDeliveredTotalsByPeriodPeriodData) {
        this.from = data.from;
        this.until = data.until;
        this.total_cost = Number(data.total_cost ?? 0);
    }
}

export class WarehouseAdminDeliveredTotalsByPeriodProductPeriodData {
    delivered: number;
    cost: number;

    constructor(data: IWarehouseAdminDeliveredTotalsByPeriodProductPeriodData) {
        this.delivered = Number(data.delivered ?? 0);
        this.cost = Number(data.cost ?? 0);
    }
}

export class WarehouseAdminDeliveredTotalsByPeriodProductData {
    id: number;
    name: string|null;
    category: {
        id: number;
        name: string|null;
    }|null;
    active: boolean;
    target_price: number|null;
    periods: WarehouseAdminDeliveredTotalsByPeriodProductPeriodData[];

    constructor(data: IWarehouseAdminDeliveredTotalsByPeriodProductData) {
        this.id = Number(data.id);
        this.name = data.name ?? null;
        this.category = data.category
            ? {
                id: Number(data.category.id),
                name: data.category.name ?? null
            }
            : null;
        this.active = Boolean(data.active);
        this.target_price = data.target_price == null
            ? null
            : Number(data.target_price);
        this.periods = (data.periods ?? []).map(
            period => new WarehouseAdminDeliveredTotalsByPeriodProductPeriodData(period)
        );
    }
}

export default class WarehouseAdminDeliveredTotalsByPeriodReportData {
    building: string;
    periods: WarehouseAdminDeliveredTotalsByPeriodPeriodData[];
    products: WarehouseAdminDeliveredTotalsByPeriodProductData[];

    constructor(data: IWarehouseAdminDeliveredTotalsByPeriodReportData) {
        this.building = data.building;
        this.periods = (data.periods ?? []).map(
            period => new WarehouseAdminDeliveredTotalsByPeriodPeriodData(period)
        );
        this.products = (data.products ?? []).map(
            product => new WarehouseAdminDeliveredTotalsByPeriodProductData(product)
        );
    }
}